import { mutationTypes } from '@/types';
import { uiStates } from '@/tools/viewState';
import isMapAvailable from './utils/isMapAvailable';
import isValidModalId from './utils/isValidModalId';

export function openModal({ commit, getters, state, dispatch }, { id }) {
	if (!isValidModalId(id, dispatch)) return;
	if (!isMapAvailable(id, getters, state, dispatch)) return;
	commit(mutationTypes.viewStateSetUiState, { id, uiState: uiStates.maximised });
}
export function toggleModal({ commit, state, getters, dispatch }, { id }) {
	if (!isValidModalId(id, dispatch)) return;
	if (!isMapAvailable(id, getters, state, dispatch)) return;
	if (state.viewState[id].uiState !== uiStates.hidden) {
		commit(mutationTypes.viewStateSetUiState, { id, uiState: uiStates.hidden });
	} else {
		commit(mutationTypes.viewStateSetUiState, { id, uiState: uiStates.maximised });
	}
}
export function closeModal({ commit, dispatch }, { id }) {
	if (!isValidModalId(id, dispatch)) return;
	commit(mutationTypes.viewStateSetUiState, { id, uiState: uiStates.hidden });
}
